import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const ballotGuideAPI = {
  /**
   * Generate a new ballot guide
   */
  generateGuide: async (electionId, addressId, options = {}) => {
    const { data } = await api.post('/ballot-guides', {
      electionId,
      addressId,
      ...options,
    });
    return data;
  },

  /**
   * Fetch a ballot guide
   */
  getGuide: async (guideId) => {
    const { data } = await api.get(`/ballot-guides/${guideId}`);
    return data;
  },

  /**
   * Update guide with user selections
   */
  updateSelections: async (guideId, selections) => {
    const { data } = await api.patch(`/ballot-guides/${guideId}/selections`, {
      selections,
    });
    return data;
  },

  /**
   * Request guide delivery (print, email, or mail)
   */
  requestDelivery: async (guideId, deliveryInfo) => {
    const { data } = await api.post(`/ballot-guides/${guideId}/deliver`, deliveryInfo);
    return data;
  },

  /**
   * Get PDF of the guide
   */
  getPDF: async (guideId) => {
    const { data } = await api.get(`/ballot-guides/${guideId}/pdf`);
    return data;
  },

  /**
   * Download PDF as blob
   */
  downloadPDF: async (guideId) => {
    const response = await api.get(`/ballot-guides/${guideId}/pdf`, {
      responseType: 'blob',
    });
    return response.data;
  },

  /**
   * Fetch all delivery requests for the authenticated user
   */
  getDeliveries: async () => {
    const { data } = await api.get('/ballot-guides/deliveries');
    return data;
  },
};
